(function () {
  'use strict';

  class ProntuarioV2Ctrl {
    constructor($uibModal, $location, Keys, Authenticator, ServiceVfiltro, FactoryVfiltro, safetyService, SolucoesEnum, FeatureFlag, $translate, FeaturehubJsSdk) {
      this.keys = Keys;
      this.authenticator = Authenticator;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.safetyService = safetyService;
      this.featureFlag = FeatureFlag;
      this.solucoesEnum = SolucoesEnum;
      this.modalService = $uibModal;
      this.translate = $translate;
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.solucaoId = this.featureFlag.SOLUCAO_REC_FACIAL ? this.solucoesEnum.RECONHECIMENTO_FACIAL : null;

      const search = $location.search();
      this.currentTab = search && search.tab ? search.tab : 'indicators';

      this.consultar();
    }

    consultar() {
      this.serviceVfiltro
        .init(
          this.factoryVfiltro.get([
            {
              name: 'uoId',
              key: this.keys.uo.name
            },
            {
              key: this.keys.dateTime.name,
              dateLimit: 30,
              format: 'YYYY-MM-DD',
              labelSegmentPersonalizado: this.translate.instant('v3gwc.vfiltro.tempo.daily'),
              defaultValues: {
                monthly: {
                  active: true,
                  dateLimit: 365
                }
              }
            },
            {
              name: 'motorista',
              key: this.keys.motorista.name,
              required: true,
              onlyActive: false
            }
          ])
        )
        .then((filtro) => {
          this.isMonthly = filtro.find((f) => f.key === this.keys.dateTime.name).value.tipo === 'monthly';
          this.vfiltroBackend = this.serviceVfiltro.getFiltroBackendNovo(filtro);
          this.authenticator.getUser().then(user => {
            this.loadReact(user);
          });
        });
    }

    loadReact(user) {
      const appName = 'safetyApp',
          componentPath = './Prontuario',
          componentId = 'safety-driver-record',
          props = {
            currentTab: this.currentTab,
            driverId: this.vfiltroBackend.motorista,
            endDate: this.vfiltroBackend.fim,
            handleOpenModalUpload: this.handleOpenModalUpload.bind(this),
            isMonthly: this.isMonthly,
            solucaoRecFacialId: this.solucaoId,
            startDate: this.vfiltroBackend.inicio,
            uoId: this.vfiltroBackend.uoId,
            user: user
          };

      this.safetyService
        .initialize()
        .then(() =>
          this.safetyService.loadReactComponent(appName, componentPath, componentId, props)
        );
    }

    handleOpenModalUpload(event) {
      this.modalService
        .open({
          animation: true,
          templateUrl: 'prontuario/modal/upload/upload-prontuario.tpl.html',
          controller: 'UploadProntuarioCtrl',
          controllerAs: '$ctrl',
          resolve: {
            motoristaId: () => this.vfiltroBackend.motorista,
            arquivo: () => event.detail,
            user: () => this.serviceVfiltro.factoryVfiltro.user
          }
        })
        .result
        .then(() => {
          /*eslint-disable */
          const ev = new Event('reload-infracoes-prontuario');
          document.dispatchEvent(ev);
          /*eslint-enable */
        });
    }

    handleGoToOldProntuario() {
      return '/prontuario-antigo';
    }
  }

  angular
    .module('ProntuarioV2Module')
    .controller('ProntuarioV2Ctrl', ProntuarioV2Ctrl);
}());
